import { Alchemy, Network } from 'alchemy-sdk';

const config = {
  apiKey: 'qEe4X9e3KcALKlMuVjlqE2wVnNiOBi7Z', // Replace with your Alchemy API key
  network: Network.BASE_MAINNET, // You can change to another network if needed
  // maxRetries: 3,
};

const alchemy = new Alchemy(config);

export default alchemy;
